import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatRadioModule } from '@angular/material/radio';
import { Order } from '../../interfaces/payment-summary.interface';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatRadioModule,
    ReactiveFormsModule
  ],
  selector: 'equine-ui-nx-donation',
  templateUrl: './donation.component.html',
  styleUrls: ['./donation.component.scss']
})
export class DonationComponent implements OnInit {
  
  private fb = inject(FormBuilder);
  @Input() donationOrder: Order | undefined;
  @Input() disabled = false;

  @Output() addDonation = new EventEmitter<"D-05" | "D-10" | "D-25">();
  @Output() removeDonation = new EventEmitter<void>();

  form = this.fb.control('');

  ngOnInit(): void {
    this.form.valueChanges.subscribe({
      next: (val) => {
        if (val === 'after') {
          this.removeDonation.emit();
        } else {
          this.addDonation.emit(val as "D-05" | "D-10" | "D-25");
        }
      }
    })
  }

}
